"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Disease {
    constructor() {
        this.code_name = '';
        this.show_order = 0;
        this.name = '';
    }
    static fromRaw(raw) {
        const code_name = raw.code_name;
        if (this.dict[code_name]) {
            return this.dict[code_name];
        }
        const disease = new Disease();
        disease.code_name = raw.code_name;
        disease.show_order = raw.show_order;
        disease.name = raw.name;
        this.dict[code_name] = disease;
        return disease;
    }
    static all() {
        let diseases = [];
        for (const key in this.dict) {
            diseases.push(this.dict[key]);
        }
        diseases = diseases.sort((a, b) => a.show_order - b.show_order);
        return diseases;
    }
}
exports.default = Disease;
Disease.dict = {};
